import styled from "styled-components";

import { largeScreen } from "src/shared/constants/screenSizes";

export const Wrapper = styled.div`
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  font-size: 22px;
  font-weight: 100;
  line-height: 40px;
  padding-bottom: 30px;

  @media screen and (max-width: ${largeScreen}px) {
    flex-direction: column;
  }
`;

export const HeaderText = styled.div`
  flex: 1;
`;
